import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "../../components/layout/header.jsx";
import LeftMenu from "../../components/layout/leftMenu.jsx";
import { backendApi } from "../../api/apiService";
import noData from "../../images/noData.png";
import { FaMoneyBillWave } from "react-icons/fa";
import { MdViewTimeline } from "react-icons/md";
import { FaLocationDot } from "react-icons/fa6";
import {
  FaAddressBook,
  FaAward,
  FaClock,
  FaEnvelope,
  FaEdit,
  FaMobile,
  FaSearchLocation,
  FaIdCardAlt,
  FaUserTie,
  FaUserCheck
} from "react-icons/fa";
import { RiUserSearchFill } from "react-icons/ri";
import { BsJoystick } from "react-icons/bs";
// import ShortListPopup from "./shortListPopup";
import { FcHighPriority } from "react-icons/fc";
import { useNavigate } from "react-router-dom";
// import ReScheduleInterviewPopup from "../schedule/reScheduleInterviewPopup";


function OnBoarding() {
  const [candidates, setCandidates] = useState([]);
  const [showShortList, setShowShortList] = useState(false);
  const [candidateId, setCandidateId] = useState("");
  const navigate = useNavigate();
  const [scheduleInterview, setScheduleInterview] = useState(false);
  const [opening, setOpening] = useState({});

  useEffect(() => {
    setTimeout(() => {
      document.getElementById("OnBoarding").classList.add("active");
    }, 500);
    viewschedules();
  }, []);

  const Cancel = () => {
    setShowShortList(false);
  };

  const viewschedules = () => {
    var req = {
      functionName: "onBoardingList",
      site_id: localStorage.getItem("siteId"),
    };
    console.log("req", req);
    backendApi(req).then((response) => {
      console.log("resp", response);
      if (response.success == "1") {
        console.log("success");
        setCandidates(response.dataset);
      } else {
        console.log("error in api");
        return false;
      }
    });
  };

  function formatDateToCustomFormat(dateString) {
    const options = {
      year: "numeric",
      month: "short",
      day: "numeric",
    };

    return new Date(dateString).toLocaleDateString("en-GB", options);
  }

  const goToEditPage = (candidateId) => {
    console.log("CID", candidateId);
    navigate(`/candidateprofile/${candidateId}`, { state: { from: 'onboard' } });
  };

  const candidateInterview = (id, data) => {
    console.log("canID", id);
    setCandidateId(id);
    setScheduleInterview(true);
    setOpening(data);
  };

  const closePopup = () => {
    viewschedules();
    setScheduleInterview(false);
  };

  const [menuClick, setMenuClick] = useState(false)
  const toggleMenu = () => {
    setMenuClick(!menuClick)
  }
  const closeMenu = () => {
    setMenuClick(false)
  }

  return (
    <>
      <div className="main-wrapper">
        <div className="top-color"></div>
        <LeftMenu menuClick={menuClick} closeMenu={closeMenu} />
        <div className="content-wrapper">
          <Header Header="On Boarding" toggleMenu={toggleMenu} menuClick={menuClick} />
          <div className="main-container">
            <div className="xilliWrap">
              <div className="card main-card">
                <div className="card-body">
                  <div className="row">
                    <div className="table-scroll">
                      {candidates.length > 0 ? (
                        <div className="table-responsive">
                          <table className="table">
                            <thead style={{ height: "30px" }}>
                              <tr>
                                <th style={{ width: "20px" }}>#</th>
                                <th style={{ textAlign: "left", width: "450px" }}>
                                  Candidate Details
                                </th>
                                {/* <th style={{ textAlign: "left", width: "450px" }}>
                              Skill Set
                            </th> */}
                                <th style={{ textAlign: "left", width: "450px" }}>
                                  Experience
                                </th>
                                {/* <th style={{ textAlign: "left", width: "200px" }}>
                              Status
                            </th> */}
                                <th style={{ textAlign: "left", width: "200px" }}>
                                  Actions
                                </th>
                              </tr>
                            </thead>
                            {candidates?.map((candidateData, index) => {
                              return (
                                <tbody>
                                  <tr>
                                    <td aria-label="Lead Summary">{index + 1}</td>
                                    <td aria-label="Lead Summary">
                                      <p className="mx-0 mb-1 lead-name">
                                        {candidateData.full_name}
                                      </p>
                                      {/* <p className="mx-0 mb-1 row">
                                    <span className="svg-icon-span">
                                      <FaAddressBook
                                        title="address"
                                        size={12}
                                      />
                                    </span>
                                    <span
                                      style={{ width: "80%", marginLeft: "2%" }}
                                    >
                                      {candidateData.address
                                        ? candidateData.address
                                        : "NA"}
                                    </span>
                                  </p> */}
                                      <p className="mx-0 mb-1 d-flex align-items-center mt-0">
                                        <span className="svg-icon-span text-secondary">
                                          <FaEnvelope title="email" size={12} />
                                        </span>
                                        <span className="text-secondary"
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {candidateData.email_id
                                            ? candidateData.email_id
                                            : "NA"}
                                        </span>
                                      </p>
                                      <p className="mx-0 mb-1 d-flex align-items-center mt-0">
                                        <span className="svg-icon-span text-secondary">
                                          <FaMobile title="Contact No:" size={12} />
                                        </span>
                                        <span className="text-secondary"
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {candidateData.mobile_no
                                            ? candidateData.mobile_no
                                            : "NA"}
                                        </span>
                                      </p>
                                      {/* <p className="mx-0 mb-1 row">
                                    <span className="svg-icon-span">
                                      <FaSearchLocation
                                        title="location"
                                        size={12}
                                      />
                                    </span>
                                    <span
                                      className="row"
                                      style={{ width: "80%", marginLeft: "2%" }}
                                    >
                                      {candidateData.location
                                        ? candidateData.location
                                        : "NA"}
                                    </span>
                                  </p> */}
                                      {/* <p className="mx-0 mb-1 row">
                                    <span className="svg-icon-span">
                                      <FaClock title="Uploaded On" size={12} />
                                    </span>
                                    <span
                                      className="row"
                                      style={{ width: "80%", marginLeft: "2%" }}
                                    >
                                      {formatDateToCustomFormat(
                                        candidateData.candidate_created_date
                                      )}
                                    </span>
                                  </p> */}
                                    </td>
                                    {/* <td
                                  aria-label="Skills"
                                  style={{ textAlign: "left" }}
                                >
                                  <span className="">
                                    <p className="mx-0 mb-1 row lead-name">
                                      <span
                                        className="row"
                                        style={{
                                          width: "100%",
                                          marginLeft: "2%",
                                        }}
                                      >
                                        {candidateData.candidate_skill_set ? (
                                          candidateData.candidate_skill_set
                                            .split(",")
                                            .map((loc, i) => (
                                              <span
                                                key={i}
                                                style={{
                                                  fontSize: 10.5,
                                                  backgroundColor: "#fdf498",
                                                  borderRadius: "5px",
                                                  margin: "0 5px 5px 0",
                                                  padding: "2px 5px",
                                                  color: "#000",
                                                }}
                                              >
                                                {loc.trim()}
                                              </span>
                                            ))
                                        ) : (
                                          <span style={{ fontSize: 12 }}>
                                            NA
                                          </span>
                                        )}
                                      </span>
                                    </p>
                                  </span>
                                </td> */}
                                    <td>
                                      <p className="mx-0 mb-1 lead-name onboarding_tag">
                                        <FaAward title="experience"  className="mt-1"/>{" "}
                                        {candidateData.total_experiance}
                                      </p>
                                      <p className="mx-0 mb-1  d-flex align-items-center">
                                        <span className="svg-icon-span">
                                          <BsJoystick title="Status" size={12} />
                                        </span>
                                        <span
                                          style={{
                                            fontSize: 10.5,
                                            backgroundColor: "#1cd31c8f",
                                            borderRadius: "5px",
                                            padding: "2px 5px",
                                            color: "#000",
                                            marginLeft: "2%" 
                                          }}
                                        >
                                          {candidateData.status}
                                        </span>
                                      </p>
                                      {/* <p className="mx-0 mb-1 row">
                                    <span className="svg-icon-span">
                                      <FaMoneyBillWave title="CTC" size={12} />
                                    </span>
                                    <span
                                      style={{ width: "80%", marginLeft: "2%" }}
                                    >
                                      {candidateData.ctc
                                        ? candidateData.ctc
                                        : "NA"}
                                    </span>
                                  </p> */}
                                      <p className="mx-0 mb-1  d-flex align-items-center">
                                        <span className="svg-icon-span ">
                                          <MdViewTimeline
                                            title="Notice Period"
                                            size={12}
                                          />
                                        </span>
                                        <span
                                          style={{ width: "80%", marginLeft: "2%" }}
                                        >
                                          {candidateData.notice_period
                                            ? candidateData.notice_period
                                            : "NA"}
                                        </span>
                                      </p>
                                      {/* <p className="mx-0 mb-1 row">
                                    <span className="svg-icon-span">
                                      <FaLocationDot
                                        title="Preferred Location"
                                        size={12}
                                      />
                                    </span>
                                    <span
                                      style={{ width: "80%", marginLeft: "2%" }}
                                    >
                                      {candidateData.preferredLocation
                                        ? candidateData.preferredLocation
                                        : "NA"}
                                    </span>
                                  </p> */}
                                    </td>
                                    {/* <td>
                                  <span>
                                    <span className="shortlist-name">
                                      ShortListed By :
                                    </span>{" "}
                                    {candidateData.shortlisted_by}
                                  </span>
                                </td> */}
                                    <td
                                      aria-label="View"

                                    >
                                      <div className="mt-1">
                                        <button
                                          className="btn-edit d-flex align-items-center m-0 h-auto"
                                          onClick={() =>
                                            goToEditPage(candidateData.id)
                                          }
                                        >
                                          Edit
                                        </button>
                                      </div>
                                      {/* 
                                  <div className="mt-1">
                                    <button
                                      className="btn-theme2 w-100 m-0 h-auto"
                                      onClick={() =>
                                        candidateInterview(
                                          candidateData.candidate_id
                                        )
                                      }
                                    >
                                      Schedule
                                    </button>
                                  </div> */}
                                      {/* {!location.state.data === "ShortListed" && (
                                  <div className="mt-1">
                                    <button
                                      className="btn-theme w-100 m-0 h-auto"
                                      onClick={() => {
                                        showShortListClick(candidateData.candidate_id)
                                      }}
                                    >
                                      ShortList
                                    </button>
                                  </div>)} */}
                                    </td>
                                  </tr>
                                </tbody>
                              );
                            })}
                          </table>
                        </div>
                      ) : (
                        <span
                          style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <h4 className="errorMsg">No Candidates Hired</h4>{" "}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* {scheduleInterview && (
            <ReScheduleInterviewPopup
              onClose={closePopup}
              candidateId={candidateId}
              opening={opening}
            />
          )} */}
      </div>
    </>
  );
}

export default OnBoarding;
